
import "../Styles/Causes.css"
import Cause1 from "../assets/Need.jpg"
import Cause2 from "../assets/Education.jpg"
import Cause3 from "../assets/Water.jpg"
const causes = [
  {
    id: 1,
    img: Cause1,
    title: "Help Children in Need"
  },
  {
    id: 2,
    img: Cause2,
    title: "Support Education"
  },
  {
    id: 3,
    img: Cause3,
    title: "Women Empowerment"
  }
];

const Causes = () => {
  return (
    <section className="causes">
      <h2>Our Causes</h2>
      <p>Our charity helps rescue people who have no hope</p>
      <div className="cause-list">
        {causes.map((cause) => (
          <div key={cause.id} className="cause-card">

            <img src={cause.img} alt={cause.title} height={300}/>
            <h3>{cause.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Causes;
